import React, { useCallback, useState } from 'react';

import cn from 'classnames';
import startCase from 'lodash/startCase';
import { useDispatch, useSelector } from 'react-redux';

import type { RosterScout } from '@modules/advancement/duck/types';
import { expandedGroupsSel } from '@modules/advancement/packRoster/duck/selectorsTyped';
import { toggleExpandGroup } from '@modules/advancement/packRoster/duck/slice';
import ExpandToggle from '@shared/components/ExpandToggle';

import styles from '../TypeMainRow/TypeMainRow.less';

interface ComponentProps {
  groupId: string;
  label: string;
  itemsCount: number;
  isMainRow: boolean;
  expanded: boolean;
  subRows: RosterScout[];
}

export default function OrderStatusRowGroup(props: ComponentProps) {
  const group = props;
  const dispatch = useDispatch();
  const expandedGroups = useSelector(expandedGroupsSel);
  const [expanded, setExpanded] = useState(
    !!expandedGroups[`order-status:${group.groupId}`],
  );

  const handleOnClick = useCallback(
    (newValue: boolean) => {
      setExpanded(newValue);
      dispatch(
        toggleExpandGroup({
          groupId: props.groupId,
          toggle: newValue,
          type: 'order-status',
        }),
      );
    },
    [dispatch, props.groupId],
  );

  return (
    <div className={styles.row}>
      <div className={styles.denInfoWrapper}>
        <div>
          <span>{startCase(group.label)}</span>
          <span className={styles.count}>({group.itemsCount})</span>
        </div>
        <ExpandToggle
          className={cn(styles.chevron, {
            [styles.noDisplay]: false,
          })}
          expanded={expanded}
          onClick={() => handleOnClick(!expanded)}
        />
      </div>
    </div>
  );
}
